import Swal from "sweetalert2";

export const sweetAlert = (title = "Success", text = "Task success", icon = "success") => {
  Swal.fire({
    title: title,
    text: text,
    icon: icon,
    confirmButtonText: "Close",
    timer: 3000,
    timerProgressBar: true,
  });
};

export const deleteAlert = async () => {
  const result = await Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    showCancelButton: true,
    confirmButtonText: "Yes, delete it!",
    confirmButtonColor: "#00ff00",
    cancelButtonColor: "#ff0000",
    cancelButtonText: "Cancel",
  });

  return result.isConfirmed;
};

export const confirmationAlert = async (title = "Are you sure?", text = "You want to create a voucher?", icon = "warning") => {
  const result = await Swal.fire({
    title: title,
    text: text,
    icon: icon,
    showCancelButton: true,
    confirmButtonText: "Yes",
    confirmButtonColor: "#00ff00",
    cancelButtonColor: "#ff0000",
    cancelButtonText: "Cancel",
  });

  return result.isConfirmed;
};
